import * as React from 'react';
import { Text, Toggle, Tooltip } from '@serodigital/ui-components';
import { ColourStatus } from '../../../components/colourStatus';

interface IWaterBoostProps {
  isBoosted: boolean;
  isScheduled: boolean;
  onToggle: (isToggled: boolean) => void;
  disabled: boolean;
}

export function WaterBoost({ isBoosted, isScheduled, onToggle, disabled = false }: IWaterBoostProps) {
  function generateLabel() {
    if (isScheduled) {
      return 'Scheduled - On';
    }

    if (isBoosted) {
      return 'Boosted - On';
    }
    return 'Boosted - Off';
  }
  function boost() {
    return (
      <>
        <Text>Boost hot water:</Text>
        <Toggle
          disabled={disabled || isScheduled}
          checked={isScheduled || disabled ? false : isBoosted}
          onChange={onToggle}
        />
      </>
    );
  }
  return (
    <div data-qa="boost-status" className="flex flex-col space-y-8">
      <div>
        <Text>Hot water status:</Text>
        <ColourStatus label={generateLabel()} />
      </div>
      <div>
        {isScheduled ? (
          <Tooltip
            data-qa="scheduled-tooptip"
            placement={'bottom'}
            TooltipComponent={() => <Text>Hot water boost is disabled while the hot water is scheduled</Text>}
            hasArrow={true}
          >
            {boost()}
          </Tooltip>
        ) : (
          boost()
        )}
      </div>
    </div>
  );
}
